import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { useSpaceAccess } from '@eggplant/routing'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  columnGap: '4px',
  alignItems: 'start'
}

const CronFieldDescription = () => {
  const [hasAccess] = useSpaceAccess()

  return (
    <div style={wrapperStyle}>
      <Paragraph>
        <strong>
          <Color variant='theme-placeholder-text'>
            {
              hasAccess &&
            'Define a custom time interval using Cron syntax. '
            }
            You are starting from the time you selected on the calendar.
          </Color>
        </strong>
      </Paragraph>
    </div>
  )
}

export default CronFieldDescription
